module.exports = __webpack_public_path__ + "img/realplayer_features09.4fdf5315.svg";